import React from 'react'
import './Center_Exp.css';

function Centerexp() {
  return (
    <>
        <div className='Outer-container-center'>
            <h1 className='head-center'>What We Help With</h1>
           <div className='container-main'> 
                <div className='ima_inner'><img className='ima_inner' src='./images/ima1.jpg' alt='none' /> <h5>Thyroid Hypothyroid, Hashimotos and Hormonal Imbalances</h5></div>
                <div className='ima_inner'><img className='ima_inner' src='./images/ima2.jpg' alt='none'/> <h5>Stubborn Weight Loss</h5></div>
                <div className='ima_inner'><img className='ima_inner' src='./images/ima3.jpg' alt='none'/> <h5>Gut Imbalances 'Yeast Overgrowth', 'Parasites', 'Bacteria Imbalance'</h5></div>
                <div className='ima_inner'><img className='ima_inner' src='./images/ima5.jpg' alt='none'/> <h5>Women's Health PCOS, Infertility, PMS, Irregular Cycles</h5></div>
                <div className='ima_inner'><img className='ima_inner' src='./images/ima6.jpg' alt='none'/> <h5> Disorders w/ Colitis, IBS, Celiac, GERD, Crohn's</h5></div>
                <div className='ima_inner'><img className='ima_inner' src='./images/ima7.jpg' alt='none'/> <h5>Blood Sugar Dysfunction</h5></div>
           </div>
        </div>

    </>
  )
}

export default Centerexp